<template>
  <w-icon-wrapper icon-name='work-download-icon'>
    <g
      id='_22_Download_Icon'
      data-name='22 Download_Icon'
      transform='translate(-0.108)'
    >
      <path
        id='Pfad_55689'
        d='M23.117,15a1,1,0,0,0-.991,1v6H2.09V16A.991.991,0,1,0,.108,16v8h24V16A1,1,0,0,0,23.117,15Z'
        data-name='Pfad 55689'
        fill='currentColor'
      />
      <path
        id='Pfad_55690'
        d='M11.964,19.711l.691-.7c.027-.025.052-.05.077-.078l2.94-2.987a1.031,1.031,0,0,0,.006-1.435.974.974,0,0,0-1.4-.006l-1.284,1.3V1.015a.991.991,0,1,0-1.982,0V15.792l-1.271-1.34a.977.977,0,0,0-1.4-.02,1.033,1.033,0,0,0-.02,1.435Z'
        data-name='Pfad 55690'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDownload' };
</script>
